import { jsxs as e, jsx as s } from "react/jsx-runtime";

import { memo as t } from "react";

import l from "@ui-components-3/icons/lib/duotone/CircleXmark";

const a = t((({label: t, labelId: a, close: r, showCloseButton: m}) => e("div", {
    className: "py-xs px-s gap-s m-s mb-xs sm:m-m sm:mb-s flex shrink-0 items-center justify-between rounded-lg bg-neutral-100",
    children: [ s("h1", {
        className: "typography-h5 sm:typography-h4 m-0 text-neutral-800 sm:leading-[32px]",
        id: a,
        children: t
    }), m && s("button", {
        type: "button",
        className: "btn-tiny btn-neutral-borderless self-start",
        onClick: r,
        children: s(l, {
            className: "h-m w-m",
            "aria-label": "Close dialog"
        })
    }) ]
})));

export { a as default };
//# sourceMappingURL=index.js.map
